import { TranslateService } from '@ngx-translate/core';
import { DropdownOption } from './dropdown-option.model';

/**
 * 共用下拉選項
 *
 * @export
 * @class TranslatableDropdownOption
 * @implements {SelectItem}
 */
export class TranslatableDropdownOption {

  dropdown: DropdownOption;

  constructor(
    private translateService: TranslateService,
    private dropdownModel: DropdownOption,
    private labelDisplayWithValue: boolean = false) {
    this.dropdown = dropdownModel;
  }

  get label(): string | undefined {
    const currentLang = this.translateService.currentLang;
    const displaylabel = (((this.dropdown.languageOther ?? []).find(x => x.i18nCode === currentLang)?.i18nValue)
      ?? this.dropdown.languageEnglish) ?? this.dropdown.name;

    if (this.labelDisplayWithValue) {
      return `${this.value} - ${displaylabel}`;
    }

    return displaylabel;
  }

  get value(): string | undefined {
    return this.dropdown.code;
  }

  get disabled(): boolean {
    return !this.dropdown.isEnable;
  }
}
